import axios from '../../helpers/axios';

export const fetchSystemMonitor = async (historyMinutes = 60) => {
  const response = await axios.get('/admin/system-monitor', {
    params: { historyMinutes },
  });

  return response.data;
};

export const blockSystemUser = async (userId, reason = '') => {
  const response = await axios.post(`/admin/system-monitor/users/${userId}/block`, { reason });
  return response.data;
};

export const unblockSystemUser = async (userId, reason = '') => {
  const response = await axios.post(`/admin/system-monitor/users/${userId}/unblock`, { reason });
  return response.data;
};

export const disconnectSystemUser = async (userId) => {
  const response = await axios.post(`/admin/system-monitor/users/${userId}/disconnect`);
  return response.data;
};

export const disconnectSystemConnection = async (socketId) => {
  const response = await axios.post(`/admin/system-monitor/connections/${encodeURIComponent(socketId)}/disconnect`);
  return response.data;
};
